// packages import
import GetAppIcon from '@mui/icons-material/GetApp'
import { Button, CircularProgress, Tooltip } from '@mui/material'
import { FC, useContext, useState } from 'react'
import { useLocation } from 'react-router-dom'
// component import
import { Alert } from '../common/Alert'
// others
import { CaseContext } from '../../context'
import { ExportCsvProps } from '../../interfaceTypes'
import { apiFetch } from '../../utils/apiRequest'

export const ExportCsv: FC<ExportCsvProps> = ({ casesLength }) => {
  const { orderBy, orderByDirection, lawTypeId, searchValue, isWorkCompleted, caseFilter } = useContext(CaseContext)
  const { pathname } = useLocation()
  const isConsultPath = pathname.includes('consult')
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const getExportFileName = () => {
    const prefix = isConsultPath ? 'consult' : ''
    const tab = caseFilter === 'close' ? 'closed' : isWorkCompleted ? 'work_completed' : 'active'
    return `${prefix ? prefix + '_' : ''}${tab}_cases.csv`
  }

  const getCsv = async () => {
    setIsLoading(!isLoading)

    try {
      const raw = JSON.stringify({
        orderBy: orderBy,
        orderByDirection: orderByDirection,
        lawTypeId: lawTypeId,
        status: caseFilter === 'close' ? 'completed' : 'active',
        searchValue: searchValue,
        isWorkCompleted: isWorkCompleted,
        isConsultCase: isConsultPath
      })

      const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/cases/export`, { method: 'POST', body: raw })
      const data = await response.text()
      const blobData = new Blob([data], { type: 'application/octet-stream' })

      if (blobData) {
        const url = window.URL.createObjectURL(blobData)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', getExportFileName())
        document.body.appendChild(link)
        link.click()
      }
      setIsLoading(false)
    } catch (err) {
      const error = err as Error
      Alert.error(error.message)
      setIsLoading(!isLoading)
    }
  }

  return (
    <Tooltip title="Export Matters (4k only)" arrow placement="top">
      <Button
        color="primary"
        variant="outlined"
        sx={{ padding: '7px' }}
        onClick={getCsv}
        disabled={isLoading || casesLength === 0}
      >
        {!isLoading ? <GetAppIcon /> : <CircularProgress size={20} color="inherit" />}
      </Button>
    </Tooltip>
  )
}
